import { useEffect, useRef, FCC } from 'react'

type FuncHandler = Falsy | (() => void)
export interface MountHandleProps {
  onMount?: FuncHandler
  onUnmount?: FuncHandler
}

export const MountHandle: FCC<MountHandleProps> = ({ onMount, onUnmount }) => {
  const mountRef = useRef<FuncHandler>(undefined)
  mountRef.current = onMount
  const unmountRef = useRef<FuncHandler>(undefined)
  unmountRef.current = onUnmount

  useEffect(() => {
    mountRef.current && mountRef.current()

    return () => {
      if (unmountRef.current) {
        unmountRef.current()
      }
    }
  }, [])

  return null
}
